<template>
	<div data-tour-scope="setting-ads">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Pubblicità</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>

						<v-data-table
							:headers="headers"
							class="elevation-0 cellanowrap"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
							hide-default-footer
							disable-pagination
							disable-sort
							:loading="!loaded"
							data-tour="table"
						>
							<template v-slot:body>
								<!-- telefono: ogni piattaforma diventa una card, le impostazioni restano dentro la card -->
								<tbody v-if="mobileCards" class="ads-cards">
									<tr v-for="(s, i) in rows" :key="s.key">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<span class="d-inline-flex align-center">
														<v-avatar size="24px" tile class="mr-2"><img :src="s.servizio.logo" :alt="s.servizio.nome" /></v-avatar>
														{{ s.servizio.nome }}
													</span>
												</template>
												<template v-slot:actions>
													<v-switch v-if="s.available" v-model="s.modello.active" color="primary" class="mt-0 pt-0 mr-2" hide-details @change="salva(s)"></v-switch>
													<v-btn small icon color="primary" :data-tour="i === 0 ? 'expand' : null" :title="aperte[s.key] ? 'Chiudi' : 'Impostazioni'" @click="apri(s)">
														<v-icon>{{ aperte[s.key] ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<service-panel v-if="aperte[s.key]" :servizio="s.servizio" :modello="s.modello" :intestazione="false" :data-tour="i === 0 ? 'settings' : null" @save="salva(s)">
													<ads-source-info :riga="s" />
													<template v-slot:azioni>
														<template v-if="s.oauth">
															<v-btn small depressed color="primary" :disabled="!s.oauth.appConfigured" :loading="collegando === s.key" @click="collega(s)"
																><v-icon left small>mdi-link-variant</v-icon>{{ s.oauth.connected ? 'Ricollega' : 'Collega' }} {{ s.oauthLabel }}</v-btn
															>
															<v-btn v-if="s.oauth.connected" small outlined color="error" @click="scollega(s)"><v-icon left small>mdi-link-variant-off</v-icon>Scollega</v-btn>
														</template>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="verifica(s)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-btn small outlined color="primary" :disabled="!s.savedActive" :loading="syncing === s.key" @click="leggi(s)"><v-icon left small>mdi-refresh</v-icon>Leggi adesso</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="(s, i) in rows">
										<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': aperte[s.key] }" @click="apri(s)">
											<td class="pr-0" style="width: 40px">
												<v-btn small icon :data-tour="i === 0 ? 'expand' : null" :title="aperte[s.key] ? 'Chiudi' : 'Impostazioni'" @click.stop="apri(s)">
													<v-icon>{{ aperte[s.key] ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="s.servizio.logo" :alt="s.servizio.nome" />
												</v-avatar>
												{{ s.servizio.nome }}
												<v-chip v-if="s.sync && s.sync.status === 'error'" x-small label outlined color="red darken-1" class="ml-2">lettura non riuscita</v-chip>
											</td>
											<td @click.stop>
												<v-switch v-if="s.available" v-model="s.modello.active" color="primary" class="mt-0" hide-details @change="salva(s)"></v-switch>
											</td>
										</tr>
										<tr v-if="aperte[s.key]" :key="s.key + '-panel'" class="as-expanded">
											<td :colspan="headers.length" class="py-3">
												<service-panel :servizio="s.servizio" :modello="s.modello" :intestazione="true" :data-tour="i === 0 ? 'settings' : null" @save="salva(s)">
													<ads-source-info :riga="s" />
													<template v-slot:azioni>
														<template v-if="s.oauth">
															<v-btn small depressed color="primary" :disabled="!s.oauth.appConfigured" :loading="collegando === s.key" @click="collega(s)"
																><v-icon left small>mdi-link-variant</v-icon>{{ s.oauth.connected ? 'Ricollega' : 'Collega' }} {{ s.oauthLabel }}</v-btn
															>
															<v-btn v-if="s.oauth.connected" small outlined color="error" @click="scollega(s)"><v-icon left small>mdi-link-variant-off</v-icon>Scollega</v-btn>
														</template>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="verifica(s)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-btn small outlined color="primary" :disabled="!s.savedActive" :loading="syncing === s.key" @click="leggi(s)"><v-icon left small>mdi-refresh</v-icon>Leggi adesso</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-container>
		</v-main>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ServicePanel from '@/views/setting/components/ServicePanel.vue';
import AdsSourceInfo from '@/components/ads/AdsSourceInfo.vue';
import MarketplaceConnectionCheck from '@/views/setting/components/MarketplaceConnectionCheck.vue';
import { createAdsSettingsTourSteps, stopAdsSettingsTour } from '@/components/ads/ads-settings-tour';
import { sourceInfo } from '@/components/ads/labels';

const ORDER = ['google', 'meta', 'tiktok', 'microsoft'];

// piattaforme collegate con OAuth all'app di Azseller: niente credenziali da scrivere, si autorizza sul sito della
// piattaforma e si sceglie l'account pubblicitario. Al ritorno l'indirizzo ha ?<chiave>=ok|error|state
const OAUTH = {
	tiktok: { api: 'ads/tiktok', label: 'TikTok', connessione: 'tiktokads' },
	microsoft: { api: 'ads/microsoft', label: 'Microsoft', connessione: 'microsoftads' },
};
const OAUTH_VUOTO = { appConfigured: false, connected: false, accounts: [], accountId: '' };

// credenziali delle piattaforme che le tengono in questa pagina (Service del backend); Google Ads usa quelle di Impostazioni -> Seo
const CREDENZIALI = {
	meta: {
		service: 'metaads',
		campi: hasToken => [
			{ key: 'adAccountId', label: 'ID account pubblicitario (es. act_123456789)' },
			{ key: 'token', label: hasToken ? 'Token del System User (salvato: lascia vuoto per non cambiarlo)' : 'Token del System User', tipo: 'password' },
		],
		configured: setting => !!(setting && setting.adAccountId && setting.hasToken),
	},
};

export default {
	name: 'AdsSettings',
	components: { TourOverlay, KeyValueCard, ServicePanel, AdsSourceInfo, MarketplaceConnectionCheck },
	setup() {
		return { tour: useTour(createAdsSettingsTourSteps(), { onStop: stopAdsSettingsTour }) };
	},
	data() {
		return {
			headers: [
				{ text: '', sortable: false },
				{ text: 'Servizio', sortable: false },
				// interruttore all'estrema destra come in Impostazioni -> Seo
				{ text: 'Status', sortable: false, width: '200px' },
			],
			rows: [],
			aperte: {},
			loaded: false,
			syncing: '',
			// documenti Service delle credenziali (setting pubblico: il token non arriva mai al BO)
			servizi: {},
			// stato dei collegamenti OAuth (TikTok, Microsoft): account autorizzati e scelto
			oauth: {},
			collegando: '',
			connectionCheck: { open: false, service: 'metaads' },
		};
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
	},
	async mounted() {
		await this.carica();
		this.esitoOauth();
	},
	beforeDestroy() {
		this.tour.stop();
	},
	methods: {
		...mapActions({ fetchSettings: 'ads/fetchSettings', saveSettings: 'ads/saveSettings', sync: 'ads/sync' }),
		// riga = piattaforma: servizio (nome, logo, campi) e modello { active, setting } come gli altri servizi
		riga(key, s) {
			const info = sourceInfo(key);
			const cred = CREDENZIALI[key];
			const doc = cred ? this.servizi[cred.service] : null;
			const setting = (doc && doc.setting) || {};
			if (OAUTH[key]) return this.rigaOauth(key, info, s);
			return {
				key,
				available: s.available,
				// con le credenziali in questa pagina basta averle salvate; Google Ads le prende da Impostazioni -> Seo
				configured: cred ? cred.configured(setting) : s.configured,
				sync: s.sync,
				savedActive: s.enabled,
				connessione: cred ? cred.service : key === 'google' ? 'googleads' : null,
				servizio: {
					nome: info.label,
					logo: info.logo,
					prossimamente: !s.available,
					titoloSwitch: 'Report finanziario',
					campi: [
						...(cred ? cred.campi(!!setting.hasToken) : []),
						{ key: 'useInReport', label: 'Usa la spesa nel conto economico (vince sui costi manuali «Pubblicità» e sulle fatture della piattaforma)', tipo: 'switch' },
					],
				},
				modello: { active: s.enabled, setting: { useInReport: s.useInReport, ...(cred ? { adAccountId: setting.adAccountId || '', token: '' } : {}) } },
			};
		},
		// TikTok, Microsoft: collegamento OAuth e scelta dell'account pubblicitario
		rigaOauth(key, info, s) {
			const o = this.oauth[key] || OAUTH_VUOTO;
			return {
				key,
				available: s.available,
				configured: !!(o.connected && o.accountId),
				sync: s.sync,
				savedActive: s.enabled,
				connessione: OAUTH[key].connessione,
				oauth: o,
				oauthLabel: OAUTH[key].label,
				servizio: {
					nome: info.label,
					logo: info.logo,
					prossimamente: !s.available,
					titoloSwitch: 'Report finanziario',
					campi: [
						...(o.connected
							? [{ key: 'accountId', label: 'Account pubblicitario', tipo: 'select', items: o.accounts.map(a => ({ value: a.id, text: a.name && a.name !== a.id ? `${a.name} (${a.id})` : a.id })) }]
							: []),
						{ key: 'useInReport', label: 'Usa la spesa nel conto economico (vince sui costi manuali «Pubblicità» e sulle fatture della piattaforma)', tipo: 'switch' },
					],
				},
				modello: { active: s.enabled, setting: { useInReport: s.useInReport, accountId: o.accountId || '' } },
			};
		},
		async carica() {
			try {
				const [res, docs, oauth] = await Promise.all([this.fetchSettings(), this.fetchServizi(), this.fetchOauth()]);
				this.servizi = docs;
				this.oauth = oauth;
				this.rows = ORDER.map(key => this.riga(key, res.sources[key]));
				this.loaded = true;
			} catch (err) {
				this.notify('error', err.message);
			}
		},
		api(path) {
			return `${this.$store.getters['settings/getUrl']}${path}`;
		},
		auth() {
			return { headers: { Authorization: `Bearer ${this.$store.getters['profile/getToken']}` } };
		},
		// documenti Service delle credenziali: { metaads: { service, active, setting } }
		async fetchServizi() {
			const nomi = Object.values(CREDENZIALI).map(c => c.service);
			const { data } = await axios.post(this.api('services'), nomi, this.auth());
			return Object.fromEntries(((data && data.data) || []).map(d => [d.service, d]));
		},
		// stato dei collegamenti OAuth: { tiktok: {...}, microsoft: {...} } (null se la chiamata non riesce)
		async fetchOauth() {
			const out = {};
			await Promise.all(
				Object.entries(OAUTH).map(async ([key, o]) => {
					try {
						out[key] = (await axios.get(this.api(o.api), this.auth())).data.data;
					} catch (e) {
						out[key] = null;
					}
				}),
			);
			return out;
		},
		// si va sul sito della piattaforma ad autorizzare l'account; al ritorno si torna qui con ?<chiave>=ok
		async collega(s) {
			this.collegando = s.key;
			try {
				const { data } = await axios.get(this.api(`${OAUTH[s.key].api}/auth-url`), this.auth());
				window.location.href = data.data.redirect;
			} catch (err) {
				this.collegando = '';
				this.notify('error', (err.response && err.response.data && err.response.data.message) || err.message);
			}
		},
		async scollega(s) {
			try {
				const { data } = await axios.post(this.api(`${OAUTH[s.key].api}/disconnect`), {}, this.auth());
				this.$set(this.oauth, s.key, data.data);
				if (s.modello.active) {
					s.modello.active = false;
					await this.salva(s);
				} else {
					Object.assign(s, this.rigaOauth(s.key, sourceInfo(s.key), { available: s.available, sync: s.sync, enabled: false, useInReport: s.modello.setting.useInReport }));
				}
				this.notify('success', `${s.servizio.nome} scollegato`);
			} catch (err) {
				this.notify('error', err.message);
			}
		},
		// esito del ritorno da TikTok o Microsoft (?tiktok=ok, ?microsoft=error, ...): messaggio e pulizia dell'indirizzo
		esitoOauth() {
			const key = Object.keys(OAUTH).find(k => this.$route.query[k]);
			if (!key) return;
			const nome = sourceInfo(key).label;
			const testi = {
				ok: ['success', `${nome} collegato: scegli l’account pubblicitario se ne hai più di uno, poi accendi la lettura`],
				state: ['error', `Il ritorno da ${nome} non corrisponde al collegamento avviato: riprova da qui`],
				error: ['error', `${nome} non ha completato il collegamento: riprova o verifica la connessione`],
			};
			const [color, text] = testi[this.$route.query[key]] || testi.error;
			this.notify(color, text);
			this.$set(this.aperte, key, true);
			this.$router.replace({ query: {} }).catch(() => {});
		},
		verifica(s) {
			this.connectionCheck = { open: true, service: s.connessione };
		},
		apri(s) {
			this.$set(this.aperte, s.key, !this.aperte[s.key]);
		},
		// la lettura si puo' accendere: credenziali salvate, oppure appena scritte nel form (si salvano con l'accensione)
		pronta(s) {
			if (s.configured) return true;
			const f = s.modello.setting || {};
			if (s.key === 'meta') return !!(f.adAccountId && (f.token || this.servizi.metaads?.setting?.hasToken));
			if (s.oauth) return !!(s.oauth.connected && f.accountId);
			return false;
		},
		// cosa manca a una piattaforma per accendere la lettura
		mancante(s) {
			if (s.key === 'google') return 'Prima configura Google Ads - Keyword Planner in Impostazioni → Seo (file JSON del service account e ID cliente).';
			if (s.key === 'meta') return 'Prima compila ID account pubblicitario e token del System User e premi Conferma.';
			if (s.oauth && !s.oauth.appConfigured) return `L’app ${s.oauthLabel} di Azseller non è ancora configurata sul server: il collegamento non è disponibile.`;
			if (s.oauth && !s.oauth.connected) return `Prima premi Collega ${s.oauthLabel} e autorizza Azseller.`;
			return 'Prima scegli l’account pubblicitario e premi Conferma.';
		},
		async salva(s) {
			if (!s.available) return;
			// accensione senza credenziali: l'interruttore torna spento, la riga si apre e si dice cosa manca
			if (s.modello.active && !this.pronta(s)) {
				this.$nextTick(() => {
					s.modello.active = false;
				});
				this.$set(this.aperte, s.key, true);
				this.notify('warning', this.mancante(s));
				return;
			}
			const accesa = s.modello.active && !s.savedActive;
			const cred = CREDENZIALI[s.key];
			try {
				// prima le credenziali (Service del backend, token cifrato): il servizio e' attivo quando la lettura e' accesa
				if (cred) {
					const { adAccountId, token } = s.modello.setting;
					const saved = this.servizi[cred.service];
					const payload = { service: cred.service, active: !!s.modello.active, setting: { ...((saved && saved.setting) || {}), adAccountId, token } };
					const { data } = await axios.post(this.api('services/update'), payload, this.auth());
					this.$set(this.servizi, cred.service, data.data);
					s.modello.setting.token = '';
				}
				// TikTok, Microsoft: account pubblicitario scelto e servizio attivo insieme alla lettura
				if (OAUTH[s.key]) {
					const { data } = await axios.put(this.api(OAUTH[s.key].api), { accountId: s.modello.setting.accountId || '', active: !!s.modello.active }, this.auth());
					this.$set(this.oauth, s.key, data.data);
				}
				const res = await this.saveSettings({ sources: { [s.key]: { enabled: !!s.modello.active, useInReport: !!s.modello.setting.useInReport } } });
				const nuova = this.riga(s.key, res.sources[s.key]);
				Object.assign(s, { configured: nuova.configured, sync: nuova.sync, savedActive: nuova.savedActive, servizio: nuova.servizio, oauth: nuova.oauth });
				if (cred) s.modello.setting.adAccountId = nuova.modello.setting.adAccountId;
				this.notify('success', accesa ? `${s.servizio.nome} attivato: lettura in corso, storico degli ultimi 13 mesi compreso` : 'Impostazioni salvate');
			} catch (err) {
				s.modello.active = s.savedActive;
				this.notify('error', (err.response && err.response.data && err.response.data.message) || err.message);
			}
		},
		async leggi(s) {
			this.syncing = s.key;
			try {
				await this.sync([s.key]);
				this.notify('info', `Lettura di ${s.servizio.nome} in coda: fra qualche minuto i numeri sono aggiornati`);
			} catch (err) {
				this.notify('error', err.message);
			} finally {
				this.syncing = '';
			}
		},
		notify(color, text) {
			this.$store.dispatch('settings/updateSnackbar', { color, text, snackbar: true, mode: 'multi-line', timeout: 6000 });
		},
	},
};
</script>

<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione (come Impostazioni -> Seo) */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
.as-expanded td {
	white-space: normal;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.ads-cards,
.ads-cards tr {
	display: block;
	width: 100%;
}
.ads-cards tr,
.ads-cards tr:hover {
	background: transparent !important;
}
.ads-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
.ads-cards tr:first-child td {
	padding-top: 12px !important;
}
.ads-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.ads-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
